import React, { ChangeEvent, FormEvent, useState } from 'react'
import * as SC from './style'
import { AiOutlineClear, AiOutlineSearch } from 'react-icons/ai'
import { AppDispatch } from '../../../../redux/app/store'
import { Date, OptionsWrapper } from '../../../../GlobalStyles'
import { getAssistansStatistics } from '../../../../redux/features/assistants/assistansSlice'
import { getAssistantsStatistics } from '../../../../services/assistants'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../../components/Button/Button'

const Options = () => {
  const dispatch = useDispatch<AppDispatch>()
  const assistansStatistics = useSelector(getAssistansStatistics)
  const [data, setData] = useState({
    initial_date: "",
    final_date: ""
  })

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    dispatch(getAssistantsStatistics({ ...data }))
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setData({
      ...data,
      [name]: value
    })
  }

  const handleClean = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    dispatch(getAssistantsStatistics({}))
    setData({
      initial_date: "",
      final_date: ""
    })
  }

  return (
    <OptionsWrapper onSubmit={handleSubmit}>
      <Date
        type="text"
        name='initial_date'
        value={data.initial_date}
        placeholder='Fecha Inicial'
        onChange={handleChange}
        onFocus={(e) => e.target.type = "date"}
        onBlur={(e) => e.target.type = "text"}
      />
      <Date
        type="text"
        name='final_date'
        value={data.final_date}
        placeholder='Fecha Final'
        onChange={handleChange}
        onFocus={(e) => e.target.type = "date"}
        onBlur={(e) => e.target.type = "text"}
      />
      <Button
        text='Buscar'
        color='var(--white)'
        background='var(--light-blue)'
        boldText={true}
        padding="10px 28px"
        svgMargin="0 0 0 13px"
      >
        <AiOutlineSearch size={35} />
      </Button>
      <Button
        text=''
        color='var(--white)'
        background='#838383'
        boldText={true}
        padding="8px 15px"
        svgMargin="0 0 0 0px"
        // @ts-ignore
        onClick={handleClean}
      ><AiOutlineClear size={40} /></Button>
      <div>
        <SC.TotalTransfers>Total de traslados</SC.TotalTransfers>
        <SC.Amount>{assistansStatistics.totalTranfers}</SC.Amount>
      </div>
    </OptionsWrapper>
  )
}

export default Options